import { escapeHtml } from '../js/html_escape.js';
var chance;
var favorites;
var storage;

$(document).on('turbo:load', function() {
    let timeout = null;
    $('body').on("keyup", '#favorite-search', async function() {
        let element_ = $("#favorite-list");
        element_.empty();
        element_.append(`<div class="row mt-3"><div class="col-12 justify-content-center text-center"><div class="spinner-border text-primary text-center" role="status"></div></div></div>`);
        let search_text = document.getElementById("favorite-search").value;
        clearTimeout(timeout);
        timeout = setTimeout(async function () {
          let suggestions = await getSuggestions(search_text);
          element_.empty();
          // <a class="align-items-center d-flex link-dark text-decoration-none" href="/orte"></a>
          $.each(suggestions.data, function(key, value) {
            element_.append(`<li class="row mt-3 c-pointer" data-id="${value["id"]}" data-name="${escapeHtml(value["name"])}" data-logo="${value["logo"]}" >
            <div class="col-10">
            <img style="height: 35px" class="img-fluid" src="${value["logo"] ? value["logo"] : '/icons/app_logo.svg'}">
            <span class="mb-0 ps-2">${escapeHtml(value["name"])}</span>
            </div>
            <div class="col-2 d-flex justify-content-end pe-0">
            <div class="icon-arrow-right-1 text-default-gray"></div>
            </div>
            <hr class="mt-1 border">
            </li>`);
          });
          if (suggestions.data.length < 1){
              element_.append(`<div style="display: flex; flex-direction: column; align-items: center;">
                                <h3 style="font-size: 1.5em;" class="fw-bold">Dein Wunschort ist nicht verfügbar?</h3>
                                <p style="margin-top: 10px;" class="text-center m-0">
                                  Schreibe uns eine Nachricht mit unserem Kontaktformular - wir nehmen
                                  Kontakt mit Deiner Verwaltung auf.
                                </p>
                              <a href="/kontakt?ort_unavailable&placeName=${encodeURIComponent(search_text)}" style="margin-top: 10px;">Zum Kontaktformular</a>
                            </div>
                          `);
          }
          $('ul#favorite-list li').click(function(e) {
              const id = $(this).data("id");
              const name = $(this).data("name");
              const logo = $(this).data("logo");
              const newFavorite = { id, name, logo };
              const favorites = JSON.parse(localStorage.getItem('favorites')) || [];
              const mainCity = JSON.parse(localStorage.getItem('main_city'));
              if (favorites.length < 10) {
                  if (favorites.some(fav => fav.id === id) && !(mainCity.id === id)) {
                      showAlert("Oops!", "Der ausgewählte Ort ist bereits unter Deinen Favoriten hinterlegt.");
                  } else {
                      if (mainCity.id === id) {
                          showAlert("Oops!", "Du kannst Deinen ausgewählten Hauptort nicht gleichzeitig auch bei den Favoriten hinterlegen.");
                      } else {
                          addFavorite(newFavorite);
                          updateList();
                          $("#favorite-list").empty();
                          Turbo.visit('/orte', { action: 'replace' });
                      }
                  }
              } else {
                  ortListFull();
              }
          });
          function showAlert(title, details) {
              $("#alert-title").text(title);
              $("#alert-details").text(details);
              $("#alert-modal").modal("show");
          }
        }, 500);
    });
    $(".add-fav-to-list").click(function(e) {
        let fav_store = JSON.parse(localStorage.getItem('favorites'));
        if (fav_store && fav_store.length >= 10) {
            ortListFull();
        } else {
            Turbo.visit('/orte/favorite', { action: 'replace' });
        }
    });
    chance = {};
    if (window.Storage != undefined) {
        storage = window.localStorage;
        if (storage.favorites == undefined) {
            favorites = [];
        } else {
            favorites = JSON.parse(storage.favorites);
            $(".fav_count").text(`${favorites.length}/10`);
        }
        updateList();
        $(document).on("click", "ul#fav-list li .remove_fav", function() {
            deleteFavorite($(this).data('id'));
            updateList();
        });
    } else {
        console.log("No support for local storage");
    }
});

function ortListFull() {
  $("#alert-title").text("Das war leider einer zu viel")
  $("#alert-details").text("Du kannst maximal 10 Orte zu Deinen Favoriten hinzufügen.")
  $("#alert-modal").modal("show");
}
function addFavorite(ort) {
    favorites.unshift(ort);
    storage.setItem('favorites', JSON.stringify(favorites));
}

function deleteFavorite(id) {
    for (var i in favorites) {
        if (favorites[i].id == id) {
            favorites.splice(i, 1);
        }
    }
    storage.setItem('favorites', JSON.stringify(favorites));
}

function updateList() {
    $('#fav-list').empty();
    if (typeof favorites !== 'undefined' && favorites.length > 0) {
        for (var i in favorites) {
            $('#fav-list').append(
                `<li class="row mt-3" data-id="${favorites[i]["id"]}">
                <a class="col-10 align-items-center d-flex link-dark text-decoration-none" href="/welcome?ort=${favorites[i]["id"]}">
                    <img style="height: 35px" class="img-fluid" src="${favorites[i]["logo"] !== 'undefined' ? favorites[i]["logo"] : '/icons/app_logo.svg'}">
                    <span class="mb-0 ps-2">${escapeHtml(favorites[i]["name"])}</span>
                </a>
                <div class="col-2 d-flex justify-content-end pe-0 align-items-center">
                  <div class="icon-arrow-right-1 text-default-gray pe-3"></div>
                  <span data-id="${favorites[i]["id"]}" class="text-default-gray c-pointer remove_fav">entfernen</span>
                </div>
                <hr class="mt-1">
                </li>`
            );
        }
    } else {
        $('#fav-list').append('<li class="text-decoration-none"> Keine Favoriten hinzugefügt </li>');
    }
}

async function getSuggestions(search) {
    const response = await fetch('/ort-search?search=' + search, {
        method: 'get',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    }).then(res => res.clone().json())
    return response;
}
